const fragmentsList = {
  bindings: {
    fragments: '<',
    loading: '<',
    filter: '<',
    onToggle: '&',
    onDelete: '&',
    hasEdit: '<',
    isLocked: '<'
  },
  templateUrl: '/modules/pis-tool/fragments/fragments-list/fragments-list.html',
  controller: 'FragmentsListController',
};

angular
  .module('pis-tool.module')
  .component('fragmentsList', fragmentsList);
